<div class="form-control" [class]="containerClass()">
  <!-- Label -->
  @if (label() || labelTemplate()) {
    <label
      class="form-control__label"
      [class]="labelClass()"
      [class.form-control__label--required]="required()"
      [class.form-control__label--disabled]="disabled()">
      @if (labelTemplate()) {
        <ng-container *ngTemplateOutlet="labelTemplate()!"></ng-container>
      } @else {
        {{ label() }}
      }
    </label>
  }

  <!-- Form Field Content -->
  <div class="form-control__field" [class.form-control__field--error]="hasError()">
    <ng-content></ng-content>
  </div>

  <!-- Hint -->
  @if (hint() || hintTemplate()) {
    <div class="form-control__hint" [class.form-control__hint--error]="hasError()">
      @if (hintTemplate()) {
        <ng-container *ngTemplateOutlet="hintTemplate()!"></ng-container>
      } @else {
        {{ hint() }}
      }
    </div>
  }

  <!-- Error Message -->
  @if (hasError()) {
    <app-form-validation-error [message]="errorText()"> </app-form-validation-error>
  }
</div>
